module.exports = "<a class=gmw-slide-nav-list-item ng-class=\"{\n    'gmw-slide-nav-list-item--disabled': disabled,\n    'gmw-slide-nav-list-item--reload': reload,\n  }\" ui-sref-active=gmw-slide-nav-list-item--active ng-transclude> </a> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/directives/dashboard-menu-nav-item/dashboard-menu-nav-item.html
// module id = 851
// module chunks = 0